<template>
  <div class="footer">
    <div class="caution">
      <h3>유의사항</h3>
      <div class="caution-inner">
        <h4>선 넘은 카드, LOCA만의 이벤트 하나!</h4>
        <ul class="footer__text">
          <li>LOCA 시리즈 카드 지난달 통합 실적 기준을 충족하지 못한
    경우, LOCA for 카드 할인혜택이 제공되지 않습니다.</li>
          <li>LOCA 카드로 LOCA for 할인 혜택을 받는 경우,
    LOCA for 카드 할인한도 내에서 혜택이 제공됩니다.</li>
          <li>본인회원이 소지한 LOCA 시리즈 카드 기준, 정상적으로
    이용이 가능한 카드만 할인 혜택을 이용할 수 있습니다. </li>
        </ul>
      </div>
      <div class="caution-inner">
        <h4>선 넘은 카드, LOCA만의 이벤트 둘!</h4>
        <ul class="footer__text">
          <li>본인 개인 신용카드를 처음  발급받는 신규회원만 혜택이
    제공됩니다.</li>
          <li>LOCA 카드 + LOCA for 카드 세트로 발급하는 경우 동시
    발급 건만 캐시백을 제공해드립니다.</li>
          <li>연회비 캐시백은 기간 내 발급카드 보유 시 제공되며,
    발급 첫 해의 연회비만 캐시백으로 제공해 드립니다.</li>
          <li>이 이벤트페이지를 통해 대상 카드를 발급받은 회원에게만
    연회비 캐시백이 제공됩니다.</li>
          <li>최근 3개월 이내 본인 또는 가족카드 탈회(해지) 이력
    보유 시 이벤트 대상에서 제외됩니다.</li>
          <li>카드모집인, 전화신청 및 다른 제휴사이트를 통한 발급
    건은 이벤트 대상에서 제외됩니다.</li>
          <li>가족카드 발급 건 및 가족카드를 이미 소지한 회원님의
    본인카드 발급 건은 이벤트 대상에서 제외됩니다.</li>
          <li>롯데카드의 다른 발급 이벤트 혜택과 중복 적용되지 않으며,
    심사기준에 따라 발급이 제한될 수 있습니다.</li>
        </ul>
      </div>
      <div class="caution-inner">
        <ul class="footer__text">
          <li>이 이벤트는 롯데카드 사정으로 변경 및 중단될 수 있으며,
    그 내용은 사전에 알려드립니다.</li>
          <li>문의 : 롯데카드 고객센터 (1588-8100)</li>
          <li>연회비 – LOCA, LOCA for Series 국내전용 : 20,000원,
    해외겸용(MASTER) : 20,000원</li>
          <li>연체이자율 : 회원별 · 이용상품별 약정이율 + 최대3%, 법정 최고금리(연24%) 이내</li>
          <li>업종을 기준으로 제공하는 서비스는 롯데카드에 등록된 가맹점의 업종을 기준으로 제공합니다.</li>
          <li>카드신청 전 상세혜택 및 이용조건은 홈페이지, 상품설명서, 약관을 확인하시기 바랍니다.</li>
          <li>신용카드 발급이 부적정한 경우(개인신용평점 낮음 등) 카드 발급이 제한될 수 있습니다.</li>
          <li>카드이용대금과 이에 수반되는 모든 수수료를 지정된 대금 결제일에 상환해야 합니다. </li>
          <li>금융소비자는 금소법 제19조 제1항에 따라 해당상품 또는 서비스에 대하여 설명을 받을 권리가 있으며, 그 설명을 듣고 내용을 충분히 이해한 후 거래하시기 바랍니다. </li>
        </ul>
      </div>
    </div>
    <div class="deliberation">
      <p>· 연체이자율 : 회원별, 이용상품별 약정이율 + 최대 3% 법정 최고금리(연20%이내) <br>*단, 연체 발생 시점에서 약정 이율이 없는 경우는 아래와 같이 적용 <br>
      &nbsp;- 일시불 거래 연체 시 : 거래 발생 시점의 최소기간(2개월) 유이자 할부 금리  <br>
      &nbsp;- 무이자 할부 거래 연체 시 : 거래 발생 시점의 동일한 할부계약기간의 유이자 할부 금리
      </p>
      <p>· 상환능력에 비해 신용카드 사용액이 과도할 경우 귀하의 개인신용평점이 하락할 수 있습니다.</p>
      <p>· 개인신용평점 하락 시 금융 거래와 관련된 불이익이 발생할 수 있습니다.</p>
      <p>· 일정기간 원리금을 연체할 경우, 모든 원리금을 변제할 의무가 발생할 수 있습니다.</p>
      <p>- 여신금융협회 심의필 제2020-C1h-07310호 (2020.08.14)</p>
    </div>
    <div class="copyright">
      <p class="logo">
        <img src="@/assets/images/footer_logo.png" alt="">
      </p>
      <p>
        서울특별시 종로구 새문안로 76 롯데카드  I  ㈜대표이사 : 조좌진<br>
        대표전화 : 1588-8100  I  사업자등록번호 : 120-81-54231<br>
        통신판매신고번호 : 제-2010-서울중구-0087호<br>
        COPYRIGHTⓒLOTTECARD CO. LTD.<br>
        All Rights Reserved.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style lang="scss" scoped>

</style>
